export function passwordResetPath(pathname) {
  try {
    const path = decodeURIComponent(pathname).replace(/\/+$/, '').toLowerCase();
    return ['/set-password', '/forgot-password', '/password-reset'].includes(path) ? path : '';
  } catch {
    return '';
  }
}

export function readResetCredentials() {
  const query = new URLSearchParams(window.location.search);
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  // Never combine a token from one URL format with an email from another.
  const source = fragment.has('user') || fragment.has('token') ? fragment : query;
  const credentials = { email: source.get('user') || '', token: source.get('token') || '' };
  if (window.location.search || window.location.hash) {
    window.history.replaceState(window.history.state, '', window.location.pathname);
  }
  return credentials;
}

export async function submitPasswordReset(endpoint, body) {
  const response = await fetch(`https://kepithor.com/${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'omit',
    cache: 'no-store',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(body),
  });
  let data;
  try { data = await response.json(); } catch { data = null; }
  return { ok: response.ok, data };
}
